<div class="register-container auth-container">
  <div class="register-card auth-card card card--raised card--pad card--roomy">
    <h2>Create Your Taptimize Account</h2>

    <form class="register-form" (ngSubmit)="onSubmit()" #registerForm="ngForm">
      <div class="field">
        <label class="field__label" for="name">Full Name</label>
        <input
          type="text"
          id="name"
          name="name"
          [(ngModel)]="registerData.name"
          required
          class="input"
          placeholder="Enter your full name">
      </div>

      <div class="field">
        <label class="field__label" for="email">Email</label>
        <input
          type="email"
          id="email"
          name="email"
          [(ngModel)]="registerData.email"
          required
          email
          class="input"
          placeholder="Enter your email">
      </div>

      <div class="field">
        <label class="field__label" for="password">Password</label>
        <input
          type="password"
          id="password"
          name="password"
          [(ngModel)]="registerData.password"
          required
          minlength="6"
          class="input"
          placeholder="Enter your password (min 6 characters)">
      </div>

      <div class="error-message" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <button
        type="submit"
        [disabled]="!registerForm.valid || isLoading"
        class="btn btn--accent btn--block">
        <span *ngIf="isLoading">Creating account...</span>
        <span *ngIf="!isLoading">Create Account</span>
      </button>
    </form>

    <div class="login-link auth-link">
      <p>Already have an account? <a href="/login" (click)="goToLogin($event)">Login here</a></p>
    </div>
  </div>
</div>
